import axios from 'axios';

export const MEMBER_AUDIT_SUCCESS = 'MEMBER_AUDIT_SUCCESS';

export const fetchAuditIssues = () => axios.get(process.env.REACT_APP_ENDPOINT_URL + '/v1/audit/issues')
    .then(response => response.data.members);

export const fetchAuditClinics = () => axios.get(process.env.REACT_APP_ENDPOINT_URL + '/v1/audit/clinics')
    .then(response => response.data.members);

export const startFullAudit = () => axios.post(process.env.REACT_APP_ENDPOINT_URL + '/v1/audit/run')
    .then(response => response.data.run);

export const fetchAuditRunStatus = () => axios.get(process.env.REACT_APP_ENDPOINT_URL + '/v1/audit/run')
    .then(response => response.data.run);

export const exportAuditCsv = async report => {
    const { data, headers } = await axios.get(process.env.REACT_APP_ENDPOINT_URL + '/v1/audit/export/' + report, { responseType: 'blob' });
    const disposition = headers && headers['content-disposition'];
    const filename = disposition && disposition.match(/filename="?([^";]+)"?/i);
    if (!filename) throw new Error('The CSV export did not include a filename.');
    const url = window.URL.createObjectURL(new Blob([data], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    try {
        link.href = url;
        link.download = filename[1];
        document.body.appendChild(link);
        link.click();
    } finally {
        link.remove();
        window.URL.revokeObjectURL(url);
    }
};

export const fetchAuditRecipients = report => axios.get(process.env.REACT_APP_ENDPOINT_URL + '/v1/audit/recipients/' + report)
    .then(response => response.data.recipients);

export const saveAuditRecipients = (report, recipients) => axios.put(process.env.REACT_APP_ENDPOINT_URL + '/v1/audit/recipients/' + report, { recipients })
    .then(response => response.data.recipients);

export const sendAuditReport = report => axios.post(process.env.REACT_APP_ENDPOINT_URL + '/v1/audit/reports/' + report + '/send')
    .then(response => response.data);

export const checkMemberIssues = id => async dispatch => {
    const { data } = await axios.post(process.env.REACT_APP_ENDPOINT_URL + '/v1/audit/members/' + id + '/check');
    dispatch({ type: MEMBER_AUDIT_SUCCESS, member: data.member, receivedAt: Date.now() });
    return data;
};
